import { interval, share } from 'rxjs';

export const secondInterval = interval(1000).pipe(share()); // to sync all countdowns
